import { DynamicConfig } from './dynamic-config';
import { Ticket, AllStatesByCodes, getStateDetails } from '../model';

type ValidationResult = { isValid: boolean; errorMessage?: string };

export function hasDisabledVenue(ticket: Ticket, dynamicConfig: DynamicConfig | undefined) {
  const disabledVenues = dynamicConfig?.DISABLED_VENUES;
  if (disabledVenues === undefined) {
    return false;
  }
  const restrictedVenues = disabledVenues.split(',');
  return restrictedVenues.includes(ticket.placedAtLocation.venueId);
}

export function hasValidFormat(retailTicketId: string) {
  return retailTicketId.match(/^\d{18}$/) !== null;
}

export function hasValidState(retailTicketId: string) {
  const regionAndState = getStateDetails(retailTicketId);
  return regionAndState?.state !== undefined;
}

export function hasEnabledState(retailTicketId: string, dynamicConfig: DynamicConfig) {
  const stateCode = getStateCode(retailTicketId);
  return dynamicConfig.ENABLED_STATES.split(',').some(es => AllStatesByCodes[stateCode] === es);
}

export function validateRetailTicketId(
  retailTicketId: string,
  dynamicConfig: DynamicConfig | undefined
): ValidationResult {
  if (dynamicConfig === undefined) {
    return { isValid: false, errorMessage: 'There has been a problem, please try again soon' };
  }

  if (!hasValidFormat(retailTicketId)) {
    return { isValid: false, errorMessage: `Retail Ticket ID '${retailTicketId}' is invalid.` };
  }
  if (!hasValidState(retailTicketId)) {
    return { isValid: false, errorMessage: `Retail Ticket ID '${retailTicketId}' has invalid state.` };
  }
  if (!hasEnabledState(retailTicketId, dynamicConfig)) {
    const stateCode = getStateCode(retailTicketId);
    const regionAndState = getStateDetails(retailTicketId);
    return {
      isValid: false,
      errorMessage: `Tracking Bets in State '${regionAndState?.state}' with code '${stateCode}' in '${regionAndState?.region}' region is not enabled.`
    };
  }
  return { isValid: true };
}

function getStateCode(retailTicketId: string) {
  return retailTicketId.substring(1, 3);
}
